import React, { useState } from 'react';

import Navbar from './navbar/navbar.component';
import Sidebar from './sidebar/sidebar.component';
import Footer from './footer/footer.component';

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <header>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <Navbar toggle={toggle} />
      </header>
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
